import { IncomingMessage } from "http";
import { getPlatform as getPlatformFromRequest } from "@asosteam/asos-web-store-presentation-node/lib/main.es5.js";
import { buildExpressRequestPagesRouter } from "./express-request";

export const getPlatform = async (req: IncomingMessage) => {
  const { request } = await buildExpressRequestPagesRouter(req);
  const platform = getPlatformFromRequest(request);
  return platform === "tablet" ? "desktop" : platform;
};
